import AntiphishingError from './AntiphishingError';
class InvestorIsNotRegistered extends AntiphishingError {
    constructor(emailAddress, options) {
        super(`The email address '${emailAddress}' is not registered`, options);
    }
}
export default InvestorIsNotRegistered;
